import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const money = (n) => `${Number(n || 0).toFixed(2).replace(".", ",")} $`;

// Reçus famille (1 reçu PDF par facture d'abonnement regroupé) : liste, PDF, renvoi, aperçu test.
export function FamilyReceiptsPanel({ groups }) {
  const [receipts, setReceipts] = useState(null);
  const [busy, setBusy] = useState("");

  const load = () => api.get("/billing/family-receipts").then((r) => setReceipts(r.data.receipts)).catch(() => setReceipts([]));
  useEffect(() => { load(); }, []);

  const openPdf = async (id) => {
    try { const r = await api.get(`/billing/family-receipts/${id}.pdf`, { responseType: "blob" }); window.open(URL.createObjectURL(r.data), "_blank"); }
    catch { toast.error("PDF indisponible"); }
  };
  const resend = async (id) => {
    setBusy(id);
    try { const r = await api.post(`/billing/family-receipts/${id}/resend`); toast[r.data.sent ? "success" : "warning"](r.data.sent ? "Reçu renvoyé au payeur" : "Non envoyé (courriel payeur manquant ou invalide)"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } finally { setBusy(""); }
  };
  const preview = async (g) => {
    setBusy(g.payer_email);
    try {
      const r = await api.post("/billing/family-receipts/generate-test", { contract_ids: g.contracts.map((c) => c.id), send: false });
      toast.success(`Aperçu ${r.data.receipt.number} généré (marqué TEST)`); load(); openPdf(r.data.receipt.id);
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } finally { setBusy(""); }
  };

  const merged = (groups || []).filter((g) => g.already_merged);

  return (
    <div className="rounded-xl border border-zinc-800 p-4" data-testid="family-receipts-panel">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-bold text-zinc-100">🧾 Reçus famille</h3>
          <p className="text-xs text-zinc-400 mt-0.5">Dès qu'une facture d'un abonnement regroupé est payée (webhook Stripe), le payeur reçoit UN reçu PDF listant les 1 ou 2 enfants, la période de 4 semaines, TPS/TVQ et le total.</p>
        </div>
      </div>
      {merged.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2" data-testid="family-receipts-preview-row">
          {merged.map((g) => (
            <button key={g.payer_email} disabled={busy === g.payer_email} onClick={() => preview(g)}
              className="px-3 py-1.5 rounded-lg border border-amber-500/50 text-amber-200 hover:bg-amber-500/10 text-xs" data-testid={`family-receipt-preview-${g.payer_email}`}>
              Aperçu reçu · {g.contracts.map((c) => c.full_name.split(" ")[0]).join(" + ")}
            </button>
          ))}
        </div>
      )}
      {!receipts && <p className="text-zinc-500 text-sm mt-3">Chargement…</p>}
      {receipts && receipts.length === 0 && <p className="text-zinc-500 text-sm mt-3" data-testid="family-receipts-empty">Aucun reçu famille émis pour l'instant.</p>}
      {receipts && receipts.length > 0 && (
        <table className="w-full text-sm mt-3" data-testid="family-receipts-table">
          <thead className="text-[11px] uppercase tracking-wider text-zinc-500"><tr><th className="text-left py-1">N°</th><th className="text-left">Payeur</th><th className="text-left">Membres</th><th className="text-left">Période</th><th className="text-right">Total</th><th></th></tr></thead>
          <tbody>
            {receipts.map((r) => (
              <tr key={r.id} className="border-t border-zinc-800/70" data-testid={`family-receipt-row-${r.id}`}>
                <td className="py-1.5 text-zinc-200">{r.number}{r.simulated && <span className="ml-1 text-[9px] uppercase text-fuchsia-300">test</span>}</td>
                <td className="text-zinc-400">{r.payer_email}</td>
                <td className="text-zinc-300">{(r.member_names || []).join(", ")}</td>
                <td className="text-zinc-400 text-xs">{r.period_start} → {r.period_end}</td>
                <td className="text-right text-amber-300 font-semibold">{money(r.total)}</td>
                <td className="text-right whitespace-nowrap">
                  <button onClick={() => openPdf(r.id)} className="text-xs text-[#C9A961] hover:underline mr-2" data-testid={`family-receipt-pdf-${r.id}`}>PDF</button>
                  <button onClick={() => resend(r.id)} disabled={busy === r.id} className="text-xs text-zinc-300 hover:underline" data-testid={`family-receipt-resend-${r.id}`}>Renvoyer{r.emails_sent?.length ? ` (${r.emails_sent.length})` : ""}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
